const LOAN_TYPES = [
  {
    label: "Credit Card",
    value: "creditcard"
  },
  {
    label: "Mortgage",
    value: "mortgage"
  },
  {
    label: "Student Loan",
    value: "studentloan"
  },
  {
    label: "Auto Loan",
    value: "autoloan"
  },
  {
    label: "Personal Loan",
    value: "personalloan"
  }
];

export const LOAN_TYPES_LABELS = LOAN_TYPES.reduce((prev, next) => {
  prev[next.value] = next.label;

  return prev;
}, {});

export default LOAN_TYPES;
